import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Por qué no puedo dejar de llorar?",
    answer:
      "Llorar con frecuencia o sin una razón clara puede ser un síntoma de depresión. Si los síntomas no mejoran con el tratamiento actual, una consulta con el equipo clínico puede ayudar a evaluar opciones.",
  },
];

export const esCantStopCrying = makeEsArticle({
  slug: "cant-stop-crying-for-no-reason",
  title: "¿Por qué no puedo dejar de llorar?",
  description:
    "Llorar con frecuencia o sin una razón clara puede ser un síntoma de depresión. Si los síntomas no mejoran, una consulta puede ayudar a evaluar opciones.",
  h1: "¿Por qué no puedo dejar de llorar?",
  breadcrumbLabel: "No poder dejar de llorar",
  shortAnswer:
    "Llorar con frecuencia o sin una razón clara puede ser un síntoma de depresión. Si estos síntomas no mejoran lo suficiente con el tratamiento actual, una consulta con el equipo clínico puede ayudar a evaluar opciones, incluida SAINT® para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. No hay garantías de resultados; los resultados individuales pueden variar.",
  keyTakeaways: [
    "Llorar con frecuencia puede ser un síntoma de depresión.",
    "Puede ocurrir sin una razón clara.",
    "Si no mejora, una consulta puede ayudar.",
    "SAINT® es una opción para adultos con trastorno depresivo mayor.",
    "No hay garantías; los resultados pueden variar.",
  ],
  sections: [
    {
      heading: "Llorar y depresión",
      paragraphs: [
        "Llorar con frecuencia, sentirse abrumado o llorar sin una razón clara pueden ser síntomas de la depresión. Si estos síntomas persisten a pesar del tratamiento, conviene revisar el plan con un profesional.",
      ],
    },
    {
      heading: "Opciones si el tratamiento no basta",
      paragraphs: [
        "Si los antidepresivos no han producido una mejoría suficiente, SAINT® es una opción autorizada por la FDA para el trastorno depresivo mayor en adultos. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
